<template>
  <div
    class="basic_nleavemessage_index"
    v-loading="loading"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn
        btnIcon="el-icon-edit"
        :tips="$t('widgets_basic_article_classification_index_336')"
        v-if="view_pattern === 'mb'"
        @changeStyle="edit_module"
      ></my_hover_btn>
      <my_hover_btn
        btnType="text"
        :title="$t('widgets_basic_article_classification_index_336')"
        v-if="view_pattern === 'pc'"
        @changeStyle="edit_module"
      ></my_hover_btn>
      <my_hover_btn
        v-if="view_pattern === 'pc'"
        :tips="$t('widgets_basic_article_classification_edit_330')"
        @changeStyle="()=>{
         this.templet.changeStyle(this.module,'animation');
      }"
        btnIcon="el-icon-magic-stick"
      ></my_hover_btn>
      <my_hover_btn
        v-if="view_pattern === 'pc'"
        :tips="$t('widgets_basic_nleavemessage_edit_2701')"
        @changeStyle="openFormEidtDialog"
        btnIcon="el-icon-edit"
      ></my_hover_btn>
      <my_hover_btn
        v-if="view_pattern === 'pc'"
        :tips="$t('widgets_basic_nleavemessage_edit_2703')"
        btnIcon="el-icon-search"
        @changeStyle="viewFormData"
      ></my_hover_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index"
                    v-if="view_pattern === 'pc'"></my_close_btn>
    </div>
    <div class="basic_nleavemessage">
      <my_title_index :title="infor.title"></my_title_index>
      <div class="module_wrap">
        <div class="module_content">
          <div class="module_content_detail m_online_form_content" v-if="seFormList.length == 0">
            <div class="jz_empty_tips">
              <i class="jz_empty_tips__img"></i>
              <div class="jz_empty_tips__text">{{$t('widgets_basic_nleavemessage_index_2707')}}</div>
              <div class="jz_empty_tips__buttons">
                <el-button type="primary" size="small" :loading="isLoading" @click="add_form">{{$t('widgets_basic_nleavemessage_edit_2697')}}</el-button>
                <el-button size="small" @click="select_form">{{$t('widgets_basic_nleavemessage_index_2708')}}</el-button>
              </div>
            </div>
          </div>
          <div class="m_form" :class="'s_'+listArr.moduleStyle" v-if="seFormList.length > 0">
            <h2
              class="form_title"
              :style="{
                  textAlign: pc_infor.form_title.radio_val !== 'hidden' ? pc_infor.form_title.custom.textAlign: '',
                  display: pc_infor.form_title.radio_val !== 'hidden' ? 'block': 'none',
                }"
            >
              <span class="form_title_text" v-text="form.title" :style="formTitleStyle"></span>
            </h2>
            <div class="dialog_content">
              <!--  @mousedown.stop -->
              <form class="my_form form-horizontal">
                <div class="form_frame">
                  <div
                    class="form_item_wrap"
                    v-for="(item,index) in form.fields.contentList"
                    data-comb-dom
                    :class="index === $store.state.app.se_item_index ? 'formitem_active_chosen' : ''"
                    v-if="($store.state.app.road_type == 1 && (item.moduleName == 'provinces'|| item.moduleName == 'IDCard')) || item.show == false ? false : true"
                    :item-id="item.id"
                    :data-id="'u' + module.widgets_id + '_' + item.id"
                    :id="'u' + module.widgets_id + '_' + item.id"
                    :key="index"
                    :style="{
                        display: item.display ? 'block': '',
                        width: item.width
                      }"
                  >
                    <div class="form_item" @click="eidtFormItem(index)">
                      <div class="jz_tooltip" v-if="$store.state.app.view_pattern === 'pc'">
                        <div class="tooptipPart module_edit_btn">
                          <my_hover_btn
                            :tips="$t('view_form_dialog_add_form_218')"
                            btnIcon="el-icon-edit"
                            @changeStyle="eidtFormItem(index)"
                          ></my_hover_btn>
                          <my_hover_btn
                            :tips="$t('widgets_basic_nleavemessage_index_2709')"
                            btnIcon="el-icon-close"
                            @changeStyle="formItemDelete(index,item)"
                          ></my_hover_btn>
                        </div>
                      </div>
                      <h3
                        class="title"
                        :style="{
                            display: pc_infor.form_item_title.radio_val !== 'hidden' ? 'block': 'none'
                          }"
                      >
                        <span class="title_text" v-text="item.title" :style="formItemTitleStyle"></span>
                        <span class="required_icon" v-if="item.require">*</span>
                      </h3>
                      <!--input-->
                      <input
                        :style="[{
                        '--fsItalics': fsItalics,
                        '--fontUnderline': fontUnderline,
                        '--fontSize': fontSize + 'px',
                        '--fsWeight': fsWeight,
                        '--fontColor': fontColor,
                        '--fontFamily': fontFamily,
                        '--textAlign': textAlign,
                        '--backgroundImage': backgroundImage,
                        background:default_formItemBg,
                        '--sebackground': se_formItemBg,
                        '--se_formItemBorderTop': se_formItemBorderTop,
                        '--se_formItemBorderBottom': se_formItemBorderBottom,
                        '--se_formItemBorderLeft': se_formItemBorderLeft,
                        '--se_formItemBorderRight': se_formItemBorderRight
                      },default_formItemBorder]"
                        v-if="item.type == 'input'
                          && item.moduleName !== 'phone'
                          && item.moduleName !== 'date'"
                        disabled="disabled"
                        :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? item.placeholder : ''"
                        class="input_style jz_focus jz_theme_focus_border_color"
                      />
                      <!-- date-->
                      <div class="item_type_date content" v-if="item.moduleName =='date'">
                        <template v-if="item.dateType === 'range'">
                          <input
                            type="text"
                            disabled="disabled"
                            :style="[{
                              '--fsItalics': fsItalics,
                              '--fontUnderline': fontUnderline,
                              '--fontSize': fontSize + 'px',
                              '--fsWeight': fsWeight,
                              '--fontColor': fontColor,
                              '--fontFamily': fontFamily,
                              '--textAlign': textAlign,
                              '--backgroundImage': backgroundImage,
                              background:default_formItemBg,
                              '--sebackground': se_formItemBg,
                              '--se_formItemBorderTop': se_formItemBorderTop,
                              '--se_formItemBorderBottom': se_formItemBorderBottom,
                              '--se_formItemBorderLeft': se_formItemBorderLeft,
                              '--se_formItemBorderRight': se_formItemBorderRight
                            },default_formItemBorder]"
                            :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? item.placeholder : ''"
                            class="input_style jz_focus jz_theme_focus_border_color"
                          />
                          <span class="connect_icon">-</span>
                          <input
                            type="text"
                            disabled="disabled"
                            :style="[{
                              '--fsItalics': fsItalics,
                              '--fontUnderline': fontUnderline,
                              '--fontSize': fontSize + 'px',
                              '--fsWeight': fsWeight,
                              '--fontColor': fontColor,
                              '--fontFamily': fontFamily,
                              '--textAlign': textAlign,
                              '--backgroundImage': backgroundImage,
                              background:default_formItemBg,
                              '--sebackground': se_formItemBg,
                              '--se_formItemBorderTop': se_formItemBorderTop,
                              '--se_formItemBorderBottom': se_formItemBorderBottom,
                              '--se_formItemBorderLeft': se_formItemBorderLeft,
                              '--se_formItemBorderRight': se_formItemBorderRight
                            },default_formItemBorder]"
                            :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? item.placeholder : ''"
                            class="input_style jz_focus jz_theme_focus_border_color"
                          />
                        </template>
                        <input
                          v-else
                          type="text"
                          disabled="disabled"
                          :style="[{
                            '--fsItalics': fsItalics,
                            '--fontUnderline': fontUnderline,
                            '--fontSize': fontSize + 'px',
                            '--fsWeight': fsWeight,
                            '--fontColor': fontColor,
                            '--fontFamily': fontFamily,
                            '--textAlign': textAlign,
                            '--backgroundImage': backgroundImage,
                            background:default_formItemBg,
                            '--sebackground': se_formItemBg,
                            '--se_formItemBorderTop': se_formItemBorderTop,
                            '--se_formItemBorderBottom': se_formItemBorderBottom,
                            '--se_formItemBorderLeft': se_formItemBorderLeft,
                            '--se_formItemBorderRight': se_formItemBorderRight
                          },default_formItemBorder]"
                          :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' && item.placeholder !== null ? item.placeholder : ''"
                          class="input_style jz_focus jz_theme_focus_border_color"
                        />
                      </div>
                      <!-- phone-->
                      <div v-if="item.moduleName =='phone'">
                        <div class="item_type_phone content">
                          <div class="phone_number_area">
                            <div
                              :class="view_pattern === 'pc' ? 'area_code_pc': 'area_code_mobi'"
                              class="select_style area_code"
                              v-if="item.areaSelect === 'true'"
                            >
                              <span v-if="view_pattern === 'pc'">
                                <input
                                  value="+1"
                                  readonly="readonly"
                                  :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? '+1': ''"
                                  :style="[{
                                    '--fsItalics': fsItalics,
                                    '--fontUnderline': fontUnderline,
                                    '--fontSize': fontSize + 'px',
                                    '--fsWeight': fsWeight,
                                    '--fontColor': fontColor,
                                    '--fontFamily': fontFamily,
                                    '--textAlign': textAlign,
                                    '--backgroundImage': backgroundImage,
                                    background:default_formItemBg,
                                    '--sebackground': se_formItemBg,
                                    '--se_formItemBorderTop': se_formItemBorderTop,
                                    '--se_formItemBorderBottom': se_formItemBorderBottom,
                                    '--se_formItemBorderLeft': se_formItemBorderLeft,
                                    '--se_formItemBorderRight': se_formItemBorderRight
                                  },default_formItemBorder]"
                                  class="select_input input_style"
                                />
                                <span class="arrow iconfont icon-jiantou pc_select_icon"></span>
                              </span>
                              <span v-else>
                                <input
                                  readonly="readonly"
                                  value="+1"
                                  :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? '+1': ''"
                                  :style="[{
                                    '--fsItalics': fsItalics,
                                    '--fontUnderline': fontUnderline,
                                    '--fontSize': fontSize + 'px',
                                    '--fsWeight': fsWeight,
                                    '--fontColor': fontColor,
                                    '--fontFamily': fontFamily,
                                    '--textAlign': textAlign,
                                    '--backgroundImage': backgroundImage,
                                    background:default_formItemBg,
                                    '--sebackground': se_formItemBg,
                                    '--se_formItemBorderTop': se_formItemBorderTop,
                                    '--se_formItemBorderBottom': se_formItemBorderBottom,
                                    '--se_formItemBorderLeft': se_formItemBorderLeft,
                                    '--se_formItemBorderRight': se_formItemBorderRight
                                  },default_formItemBorder]"
                                  class="select_input input_style"
                                />
                                <span class="arrow iconfont icon-jiantou"></span>
                              </span>
                            </div>
                            <div class="phone_number_wrap">
                              <input
                                maxlength="11"
                                :style="[{
                                  '--fsItalics': fsItalics,
                                  '--fontUnderline': fontUnderline,
                                  '--fontSize': fontSize + 'px',
                                  '--fsWeight': fsWeight,
                                  '--fontColor': fontColor,
                                  '--fontFamily': fontFamily,
                                  '--textAlign': textAlign,
                                  '--backgroundImage': backgroundImage,
                                  background:default_formItemBg,
                                  '--sebackground': se_formItemBg,
                                  '--se_formItemBorderTop': se_formItemBorderTop,
                                  '--se_formItemBorderBottom': se_formItemBorderBottom,
                                  '--se_formItemBorderLeft': se_formItemBorderLeft,
                                  '--se_formItemBorderRight': se_formItemBorderRight
                                },default_formItemBorder]"
                                disabled="disabled"
                                :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? item.placeholder : ''"
                                class="input_style jz_focus jz_theme_focus_border_color"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--radio-->
                      <div class="item_type_radio content" v-if="item.type=='radio'">
                        <ul class="radio_style">
                          <li
                            class="radio_item"
                            v-for="(option,index) in item.selectItem.split('\n')"
                            :key="index"
                            v-if="option !== ''"
                            :style="[{
                              '--enterColor':enterColor
                            }]"
                          >
                            {{ option }}
                            <span
                              class="radio_inner jz_theme_color iconfont icon-yuanxing"
                            ></span>
                          </li>
                        </ul>
                      </div>
                      <!--checkbox-->
                      <div class="item_type_checkbox content" v-if="item.type=='checkbox'">
                        <ul class="checkbox_style">
                          <li
                            class="checkbox_item"
                            v-for="(option,index) in item.selectItem.split('\n')"
                            :key="index"
                            v-if="option !== ''"
                            :style="[{
                              '--enterColor':enterColor
                            }]"
                          >
                            {{ option }}
                            <span
                              class="checkbox_inner iconfont icon-fangxing jz_theme_color"
                            ></span>
                          </li>
                        </ul>
                      </div>
                      <!--select-->
                      <div class="item_type_city content" v-if="item.type=='select'">
                        <div class="select_wrap pc_select">
                          <div class="select_style">
                            <input
                              readonly="readonly"
                              :style="[{
                                '--fsItalics': fsItalics,
                                '--fontUnderline': fontUnderline,
                                '--fontSize': fontSize + 'px',
                                '--fsWeight': fsWeight,
                                '--fontColor': fontColor,
                                '--fontFamily': fontFamily,
                                '--textAlign': textAlign,
                                '--backgroundImage': backgroundImage,
                                background:default_formItemBg,
                                '--sebackground': se_formItemBg,
                                '--se_formItemBorderTop': se_formItemBorderTop,
                                '--se_formItemBorderBottom': se_formItemBorderBottom,
                                '--se_formItemBorderLeft': se_formItemBorderLeft,
                                '--se_formItemBorderRight': se_formItemBorderRight
                              },default_formItemBorder]"
                              :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? item.placeholder : ''"
                              class="pc_select_input select_input input_style"
                            />
                            <span class="arrow iconfont icon-jiantou pc_select_icon"></span>
                          </div>
                        </div>
                      </div>
                      <!--provinces-->
                      <div class="item_type_city content" v-if="item.type == 'provinces'">
                        <div class="select_wrap pc_select">
                          <div class="select_style">
                            <input
                              :style="[{
                              '--fsItalics': fsItalics,
                              '--fontUnderline': fontUnderline,
                              '--fontSize': fontSize + 'px',
                              '--fsWeight': fsWeight,
                              '--fontColor': fontColor,
                              '--fontFamily': fontFamily,
                              '--textAlign': textAlign,
                              '--backgroundImage': backgroundImage,
                              background:default_formItemBg,
                              '--sebackground': se_formItemBg,
                              '--se_formItemBorderTop': se_formItemBorderTop,
                              '--se_formItemBorderBottom': se_formItemBorderBottom,
                              '--se_formItemBorderLeft': se_formItemBorderLeft,
                              '--se_formItemBorderRight': se_formItemBorderRight
                            },default_formItemBorder]"
                              :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? $t('view_dialog_index_116') : ''"
                              readonly="readonly"
                              disabled="disabled"
                              class="select_input input_style"
                            />
                            <span class="arrow iconfont icon-jiantou" v-if="view_pattern === 'pc'"></span>
                          </div>
                        </div>
                        <div class="select_wrap pc_select" v-if="view_pattern === 'pc'">
                          <div class="select_style">
                            <input
                              :style="[{
                              '--fsItalics': fsItalics,
                              '--fontUnderline': fontUnderline,
                              '--fontSize': fontSize + 'px',
                              '--fsWeight': fsWeight,
                              '--fontColor': fontColor,
                              '--fontFamily': fontFamily,
                              '--textAlign': textAlign,
                              '--backgroundImage': backgroundImage,
                              background:default_formItemBg,
                              '--sebackground': se_formItemBg,
                              '--se_formItemBorderTop': se_formItemBorderTop,
                              '--se_formItemBorderBottom': se_formItemBorderBottom,
                              '--se_formItemBorderLeft': se_formItemBorderLeft,
                              '--se_formItemBorderRight': se_formItemBorderRight
                            },default_formItemBorder]"
                              readonly="readonly"
                              disabled="disabled"
                              :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? $t('view_dialog_index_116') : ''"
                              class="select_input input_style"
                            />
                            <span class="arrow iconfont icon-jiantou"></span>
                          </div>
                        </div>
                        <div
                          class="select_wrap pc_select"
                          v-if="item.countySelect == 'true' && view_pattern === 'pc'"
                        >
                          <div class="select_style">
                            <input
                              :style="[{
                              '--fsItalics': fsItalics,
                              '--fontUnderline': fontUnderline,
                              '--fontSize': fontSize + 'px',
                              '--fsWeight': fsWeight,
                              '--fontColor': fontColor,
                              '--fontFamily': fontFamily,
                              '--textAlign': textAlign,
                              '--backgroundImage': backgroundImage,
                              background:default_formItemBg,
                              '--sebackground': se_formItemBg,
                              '--se_formItemBorderTop': se_formItemBorderTop,
                              '--se_formItemBorderBottom': se_formItemBorderBottom,
                              '--se_formItemBorderLeft': se_formItemBorderLeft,
                              '--se_formItemBorderRight': se_formItemBorderRight
                            },default_formItemBorder]"
                              readonly="readonly"
                              disabled="disabled"
                              :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? $t('view_dialog_index_116') : ''"
                              class="select_input input_style"
                            />
                            <span class="arrow iconfont icon-jiantou"></span>
                          </div>
                        </div>
                      </div>
                      <!--textarea-->
                      <div class="item_type_textarea content" v-if="item.type == 'textarea'">
                        <textarea
                          disabled="disabled"
                          maxlength="1000"
                          :style="[{
                            '--fsItalics': fsItalics,
                            '--fontUnderline': fontUnderline,
                            '--fontSize': fontSize + 'px',
                            '--fsWeight': fsWeight,
                            '--fontColor': fontColor,
                            '--fontFamily': fontFamily,
                            '--textAlign': textAlign,
                            '--backgroundImage': backgroundImage,
                            background:default_formItemBg,
                            '--sebackground': se_formItemBg,
                            '--se_formItemBorderTop': se_formItemBorderTop,
                            '--se_formItemBorderBottom': se_formItemBorderBottom,
                            '--se_formItemBorderLeft': se_formItemBorderLeft,
                            '--se_formItemBorderRight': se_formItemBorderRight
                          },default_formItemBorder]"
                          :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? item.placeholder : ''"
                          class="textarea_style jz_focus jz_theme_focus_border_color"
                        ></textarea>
                      </div>
                      <!-- <div class="resize_handler jz_tooltip"></div> -->
                      <div class="tips_size">
                        <p class="width_num tips"></p>
                        <p class="height_num tips"></p>
                      </div>
                    </div>
                  </div>
                  <!--verify-->
                  <div
                  v-if="form.fields.verifyCodeShow
                  || typeof form.fields.verifyCodeShow == 'undefined'"
                    :class="cur_id == 'verify' ? 'formitem_active': ''"
                    item-id="verify"
                    class="form_item_wrap fixed_item formitem_validateCode drap_disabled"
                    :id="'u' + module.widgets_id + '_verify'"
                    :data-id="'u' + module.widgets_id + '_verify'"
                    data-comb-dom
                    :style="{
                    width: form.fields.verifyWidth
                  }"
                  >
                    <div class="form_item">
                      <div class="item_type_validateCode content">
                        <input
                          :style="[{
                          '--fsItalics': fsItalics,
                          '--fontUnderline': fontUnderline,
                          '--fontSize': fontSize + 'px',
                          '--fsWeight': fsWeight,
                          '--fontColor': fontColor,
                          '--fontFamily': fontFamily,
                          '--textAlign': textAlign,
                          '--backgroundImage': backgroundImage,
                          background:default_formItemBg,
                          '--sebackground': se_formItemBg,
                          '--se_formItemBorderTop': se_formItemBorderTop,
                          '--se_formItemBorderBottom': se_formItemBorderBottom,
                          '--se_formItemBorderLeft': se_formItemBorderLeft,
                          '--se_formItemBorderRight': se_formItemBorderRight
                        },default_formItemBorder]"
                          :placeholder="pc_infor.form_item_content.radio_val !== 'hidden' ? getLang($t('view_login_index_47')) : ''"
                          maxlength="4"
                          disabled="disabled"
                          class="validateCode_input input_style jz_focus jz_theme_focus_border_color"
                        />
                        <img alt=" " src="/static/image/verify.png" class="validateCode_img"/>
                      </div>
                      <!-- <div class="resize_handler jz_tooltip"></div> -->
                      <div class="tips_size">
                        <p class="width_num tips"></p>
                        <p class="height_num tips"></p>
                      </div>
                    </div>
                  </div>
                  <!--button-->
                  <div
                    :class="cur_id == 'button' ? 'formitem_active': ''"
                    item-id="button"
                    class="form_item_wrap fixed_item formitem_submit drap_disabled"
                    :id="'u' + module.widgets_id + '_button'"
                    :data-id="'u' + module.widgets_id + '_button'"
                    data-comb-dom
                    :style="{
                  textAlign: form.fields.textAlign,
                  width: form.fields.buttonWidth
                }"
                  >
                    <div class="form_item" @click.stop="editButton">
                      <div class="jz_tooltip" v-if="$store.state.app.view_pattern === 'pc'">
                        <div class="tooptipPart module_edit_btn">
                          <my_hover_btn
                            :tips="$t('widgets_basic_nleavemessage_index_2710')"
                            btnIcon="el-icon-edit"
                            @changeStyle="editButton"
                          ></my_hover_btn>
                        </div>
                      </div>
                      <button
                        class="form_submit content jz_theme_bg_color"
                        :style="buttonStyle"
                        type="button"
                        @click.stop="submitForm"
                        @dblclick="editButton"
                        v-text="form.fields.buttonName"
                      ></button>
                      <!-- <div class="resize_handler jz_tooltip"></div> -->
                      <div class="tips_size">
                        <p class="width_num tips"></p>
                        <p class="height_num tips"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {basic_nleavemessage_new_style} from "@/base/widgets_data_compatible";

export default {
  name: "basic_nleavemessage_index",
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isHover: false,
      timer: null,
      loading: false,
      cur_id: "",
      isLoading: false,
      seFormList: []
    };
  },
  methods: {
    formItemDelete(index, item) {
      if (item.isSystem) {
        this.$message.warning(i18n.t('widgets_basic_nleavemessage_index_2711'));
        return false;
      }
      this.$confirm(i18n.t('widgets_basic_nleavemessage_index_2712') + item.title + '"？', "", {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog form_item",
        appendToBody: true
      })
        .then(() => {
          this.form.fields.contentList.splice(index, 1);
          this.$store.commit("add_form_item/set_form_item_type", "edit");
          this.$store.commit("app/SET_is_change", true);
          this.templet.dialog_close()
        })
        .catch(() => {
        });
    },
    module_isHover(val) {
      this.isHover = val;
    },
    openFormEidtDialog() {
      this.$store.commit("main_dialog/Change_main_dialog_isShow", true);
      this.$store.commit("main_dialog/Change_edit_name", "basic_form");
      this.$store.commit("app/SET_module_Data", this.module);
      this.$store.commit("main_dialog/set_tabs_name", "edit_form");
      this.$store.commit("app/set_se_item_index", -1);
      this.$store.commit("app/set_form_item_tab", "add");
      this.$store.commit("app/set_form_item_is_button", false);
      this.$store.commit("add_form/set_form_type", "edit");
    },
    viewFormData() {
      // window.open(this.$store.state.app.manageFormURL);
      window.open(this.$store.getters['app/form_list_link'] );
    },
    submitForm() {
      let timers = this.timer;
      if (timers) {
        window.clearTimeout(timers);
        this.timer = null;
      }
      this.timer = window.setTimeout(() => {
        this.$message({
          showClose: true,
          message: i18n.t('components_set_link_components_submit_form_index_2470')
        });
      }, 300);
    },
    eidtFormItem(val) {
      if (this.view_pattern === "mb") {
        return false;
      }
      this.openFormEidtDialog();
      this.$store.commit("app/set_se_item_index", val);
      this.$store.commit("app/set_form_item_tab", "edit");

      this.show_mongolia(val)
    },
    show_mongolia(index) {
      this.$store.commit("row/SET_edit_mongolia", true)
      this.$store.commit("row/SET_edit_mongolia_horizontal", true)
      this.$nextTick(() => {
        //计算蒙层
        this.templet.calculation_mongolia(this.module)
        this.templet.calculation_mongolia_horizontal(this.module)
      })
    },
    async add_form() {
      let that = this
      that.isLoading = true
      if (that.$store.state.app.formList.length >= 20) {
        that.$message.error(i18n.t('view_dialog_index_171'));
        that.isLoading = false
        return false;
      }
      const form = that.$store.state.add_form.default_form;
      form.title = that.templet.getFormName(that.$store.state.app.formList);
      that.$store.commit("add_form/set_form_type", "add");
      const result = await that.templet.addForm(form)
      if (result === 'true') {
        const arr = await that.templet.getFormList()
        if (arr !== '' && arr instanceof Array) {
          that.isLoading = false
        }
      } else {
        setTimeout(() => {
          that.isLoading = false
        }, 200)
      }
      that.module.data.listArr.id = ''
      that.templet.changeStyle(that.module, "style");
    },
    edit_module() {
      this.templet.changeStyle(this.module, "style");
    },
    select_form() {
      let formList = this.$store.state.app.formList
      if (formList.length > 0) {
        this.listArr.id = formList[0].id
      }
      this.templet.changeStyle(this.module, "style");
    },
    editButton() {
      if (this.view_pattern == "mb") {
        return false;
      }
      let timers = this.timer;
      if (timers) {
        window.clearTimeout(timers);
        this.timer = null;
      }
      this.openFormEidtDialog();
      this.$store.commit("app/set_form_item_tab", "edit");
      this.$store.commit("app/set_form_item_is_button", true);
      this.show_mongolia(true)
    },
    //拖拽和缩放，公共的更新数据
    update_data({dom, width}) {
      const that = this;
      const parentWidth = $("#u" + that.module.widgets_id)
        .find(".form-horizontal")
        .width();
      const persent = Math.round(parseFloat(width / parentWidth) * 100);
      let formItem = {};
      if (that.cur_id == "verify" || that.cur_id == "button") {
        let key = that.cur_id + "Width";
        that.form.fields[key] = persent + "%";
      } else {
        const list = that.form.fields.contentList.filter((item, index) => {
          return parseInt(item.id) === parseInt(that.cur_id);
        });
        if (list.length > 0) {
          formItem = list[0];
          formItem.width = persent + "%";
        }
      }
      that.$store.commit("add_form_item/set_form_item_type", "edit");
    },
    my_resizable() {
      const that = this;
      let isDisabled = false;
      if (that.$store.state.app.view_pattern == "mb") {
        isDisabled = true;
      }
      $("#u" + that.module.widgets_id)
        .find(".form_item_wrap")
        .resizable({
          containment: "parent",
          autoHide: true,
          disabled: isDisabled,
          handles: "e",
          start: function (event, ui) {
            that.cur_id = $($(this)[0]).attr("item-id");
            that.templet.aline_start(that, $(this), '.form_item_wrap');
            $(this).find('.form_item .tips_size').show()
          },
          resize: function (event, ui) {
            $(this).children('.form_item').addClass('form_item_select');
            that.templet.use_aline_drag($(this).attr('id').slice(1));
            that.change_size_tips($(this))
          },
          stop: function (event, ui) {
            that.update_data({
              dom: $(this),
              width: ui.size.width
            });
            that.cur_id = "";
            that.$store.commit("app/SET_is_change", true);
            $(this).children('.form_item').removeClass('form_item_select');
            that.templet.p_remove_line();
            that.$store.commit('align/clear_targetDom');
            $(this).find('.form_item .tips_size').hide()
            $(this).find('.ui-resizable-e').css('display', 'none')
          }
        });
    },
    change_size_tips($this) {
      // console.log($this)
      const $dom = $this
      const w = $dom.width();
      const h = $dom.height();
      $dom.find('.width_num').text(i18n.t('widgets_basic_nleavemessage_index_2713') + w + 'px');
      $dom.find('.height_num').text(i18n.t('widgets_basic_nleavemessage_index_2714') + h + 'px');
    },
    list_sortable() {
      const that = this;
      let isDisabled = false;
      if (that.$store.state.app.view_pattern == "mb") {
        isDisabled = true;
      }
      $("#u" + that.module.widgets_id)
        .find(".form-horizontal")
        .sortable({
          placeholder: "form_item_placeholder",
          disabled: isDisabled,
          //appendTo: "body",
          cancel: ".ui-resizable-handle",
          helper: "clone",
          containment: "parent",
          items: ".form_item_wrap",
          cancel: ".drap_disabled",
          tolerance: "pointer",
          start(event, ui) {
            const dom_w = ui.item.width();
            const dom_height = ui.item.height();
            ui.placeholder.css({
              width: dom_w + "px",
              height: dom_height + "px"
            });
          },
          sort(event, ui) {
          },
          stop(event, ui) {
            const doms = $(this).find(".form_item_wrap");
            let new_modules = [];
            for (let i = 0; i < doms.length; i++) {
              const id = $(doms[i]).attr("item-id");
              for (let j = 0; j < that.form.fields.contentList.length; j++) {
                if (
                  id !== undefined &&
                  id == that.form.fields.contentList[j].id
                ) {
                  new_modules.push(that.form.fields.contentList[j]);
                }
              }
            }
            that.form.fields.contentList = [];
            that.$nextTick(() => {
              that.form.fields.contentList = new_modules;
              that.$store.commit("add_form_item/set_form_item_type", "edit");
              that.$store.commit("app/SET_is_change", true);
              that.$nextTick(() => {
                that.my_resizable();
              });
            });
          }
        });
    }
  },
  watch: {
    "$store.state.app.view_pattern"(val) {
      this.list_sortable();
      this.my_resizable();
    },
    form: {
      handler(val) {
        this.list_sortable();
        this.my_resizable();
      },
      deep: true
    },
    "module.data.listArr.id"(val) {
      this.$store.state.app.se_form_id[this.module.widgets_id] = val;
    },
    "$store.state.app.formList": {
      handler(val) {
        this.$nextTick(() => {
          if (
            !$("#u" + this.module.widgets_id)
              .find(".form-horizontal")
              .hasClass("ui-sortable")
          ) {
            this.list_sortable();
            console.log("重新绑定sortable");
          }
        });
      },
      deep: true
    }
  },
  computed: {
    fsItalics() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      return infor.form_item_content[radio_val].fsItalics;
    },
    fontUnderline() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      return infor.form_item_content[radio_val].fontUnderline;
    },
    fsWeight() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      return infor.form_item_content[radio_val].fsWeight;
    },
    fontSize() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      return infor.form_item_content[radio_val].fontSize;
    },
    fontColor() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      let color = ''
      let pattern = infor.form_item_content[radio_val].pattern;
      if (pattern === "linear_gradient") {
        color = "transparent"
      } else {
        color = infor.form_item_content[radio_val].fontColor
      }

      return color
    },
    enterColor() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      let color = ''
      let pattern = infor.form_item_content[radio_val].pattern;
      if (pattern === "linear_gradient") {
        color = "transparent"
      } else {
        color = infor.form_item_content[radio_val].enterColor
      }

      return color
    },
    fontFamily() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      return infor.form_item_content[radio_val].fontFamily;
    },

    textAlign() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      return infor.form_item_content[radio_val].textAlign;
    },
    backgroundImage() {
      const infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_content.radio_val
      const background =
        infor.form_item_content[radio_val].pattern == 'linear_gradient'
          ? 'linear-gradient(' +
          infor.form_item_content[radio_val].linear_gradient.deg +
          'deg,' +
          infor.form_item_content[radio_val].linear_gradient.start_color +
          infor.form_item_content[radio_val].linear_gradient.start_pointer +
          '%,' +
          infor.form_item_content[radio_val].linear_gradient.end_color +
          infor.form_item_content[radio_val].linear_gradient.end_pointer +
          '%)'
          : '';
      return background;
    },

    form() {
      let that = this;
      let se_id = that.module.data.listArr.id;
      let formList = that.$store.state.app.formList;
      let form = {
        title: "",
        id: "",
        fields: {
          contentList: [],
          buttonName: i18n.t('widgets_basic_nleavemessage_edit_2706'),
          popupName: i18n.t('base_options_config_1750'),
          textAlign: "left"
        }
      };
      if (formList.length > 0) {
        if (se_id !== '') {
          this.seFormList = formList.filter((item, index) => {
            return se_id == item.id;
          });
        } else {
          this.seFormList = formList.filter((item, index) => {
            return index == 0;
          });
        }

      }
      if (this.seFormList.length > 0) {
        form = this.seFormList[0];
        if (typeof form.fields == "string") {
          form.fields = JSON.parse(form.fields);
        }
        that.module.data.listArr.id = form.id;
      }
      return form;
    },
    listArr() {
      return this.module.data.listArr;
    },
    infor() {
      return this.module.data[
      this.$store.state.app.view_pattern + "_widgets_infor"
        ];
    },
    view_pattern() {
      return this.$store.state.app.view_pattern;
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    formTitleStyle() {
      let infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_title.radio_val;
      if (radio_val == "hidden") {
        return false;
      }
      let pattern = infor.form_title[radio_val].pattern;
      let color = infor.form_title[radio_val].fontColor;
      let backgroundImage = "";
      let linear_gradient = infor.form_title[radio_val].linear_gradient;
      if (pattern === "linear_gradient") {
        color = "transparent";
        backgroundImage =
          "linear-gradient(" +
          linear_gradient.deg +
          "deg," +
          linear_gradient.start_color +
          " " +
          linear_gradient.start_pointer +
          "%," +
          linear_gradient.end_color +
          " " +
          linear_gradient.end_pointer +
          "%)";
      }
      let style = {
        fontStyle: infor.form_title[radio_val].fsItalics,
        textDecoration: infor.form_title[radio_val].fontUnderline,
        fontWeight: infor.form_title[radio_val].fsWeight,
        color: color,
        fontFamily: infor.form_title[radio_val].fontFamily,
        fontSize: infor.form_title[radio_val].fontSize + "px",
        backgroundImage: backgroundImage,
        // paddingRight: 10 + "px"
      };
      return style;
    },
    formItemTitleStyle() {
      let infor = this.module.data.pc_widgets_infor;
      let radio_val = infor.form_item_title.radio_val;
      if (radio_val === "hidden") {
        return false;
      }
      let pattern = infor.form_item_title[radio_val].pattern;
      let color = infor.form_item_title[radio_val].fontColor;
      let backgroundImage = "";
      let linear_gradient = infor.form_item_title[radio_val].linear_gradient;
      if (pattern === "linear_gradient") {
        color = "transparent";
        backgroundImage =
          "linear-gradient(" +
          linear_gradient.deg +
          "deg," +
          linear_gradient.start_color +
          " " +
          linear_gradient.start_pointer +
          "%," +
          linear_gradient.end_color +
          " " +
          linear_gradient.end_pointer +
          "%)";
      }
      let style = {
        fontStyle: infor.form_item_title[radio_val].fsItalics,
        textDecoration: infor.form_item_title[radio_val].fontUnderline,
        fontWeight: infor.form_item_title[radio_val].fsWeight,
        color: color,
        fontFamily: infor.form_item_title[radio_val].fontFamily,
        fontSize: infor.form_item_title[radio_val].fontSize + "px",
        backgroundImage: backgroundImage,
        paddingRight: 10 + "px"
      };
      return style;
    },
    buttonStyle() {
      return {
        backgroundColor: this.$store.state.myRender.common.theme_color
      };
    },
    default_formItemBorder() {
      let infor = this.module.data.pc_widgets_infor;
      let listArr = this.module.data.listArr
      let radio_val = infor.form_item_border.radio_val;
      let borderWidth = infor.form_item_border[radio_val].borderWidth
      let borderColor = infor.form_item_border[radio_val].borderColor
      let style = {
        borderTop: listArr.moduleStyle == 0 || listArr.moduleStyle == 2 ? 'none' : `${borderWidth}px solid ${borderColor}`,
        borderLeft: listArr.moduleStyle == 0 || listArr.moduleStyle == 2 ? 'none' : `${borderWidth}px solid ${borderColor}`,
        borderRight: listArr.moduleStyle == 0 || listArr.moduleStyle == 2 ? 'none' : `${borderWidth}px solid ${borderColor}`,
        borderBottom: listArr.moduleStyle == 0 ? 'none' : `${borderWidth}px solid ${borderColor}`
      };
      return style;
    },
    se_formItemBorderTop() {
      return this.module.data.listArr.moduleStyle == 0 || this.module.data.listArr.moduleStyle == 2 ? 'none' : `${this.module.data.pc_widgets_infor.form_item_border[this.module.data.pc_widgets_infor.form_item_border.radio_val].borderWidth}px solid ${this.module.data.pc_widgets_infor.form_item_border[this.module.data.pc_widgets_infor.form_item_border.radio_val].seBorderColor}`;
    },
    se_formItemBorderRight() {
      return this.module.data.listArr.moduleStyle == 0 || this.module.data.listArr.moduleStyle == 2 ? 'none' : `${this.module.data.pc_widgets_infor.form_item_border[this.module.data.pc_widgets_infor.form_item_border.radio_val].borderWidth}px solid ${this.module.data.pc_widgets_infor.form_item_border[this.module.data.pc_widgets_infor.form_item_border.radio_val].seBorderColor}`;
    },
    se_formItemBorderLeft() {
      return this.module.data.listArr.moduleStyle == 0 || this.module.data.listArr.moduleStyle == 2 ? 'none' : `${this.module.data.pc_widgets_infor.form_item_border[this.module.data.pc_widgets_infor.form_item_border.radio_val].borderWidth}px solid ${this.module.data.pc_widgets_infor.form_item_border[this.module.data.pc_widgets_infor.form_item_border.radio_val].seBorderColor}`;
    },
    se_formItemBorderBottom() {
      return this.module.data.listArr.moduleStyle == 0 ? 'none' : `${this.module.data.pc_widgets_infor.form_item_border[this.module.data.pc_widgets_infor.form_item_border.radio_val].borderWidth}px solid ${this.module.data.pc_widgets_infor.form_item_border[this.module.data.pc_widgets_infor.form_item_border.radio_val].seBorderColor}`;
    },
    default_formItemBg() {
      let infor = this.module.data.pc_widgets_infor;
      const background =
        infor.form_item_bg[infor.form_item_bg.radio_val].pattern == 'linear_gradient'
          ? 'linear-gradient(' +
          infor.form_item_bg[infor.form_item_bg.radio_val].linear_gradient.deg +
          'deg,' +
          infor.form_item_bg[infor.form_item_bg.radio_val].linear_gradient.start_color +
          infor.form_item_bg[infor.form_item_bg.radio_val].linear_gradient.start_pointer +
          '%,' +
          infor.form_item_bg[infor.form_item_bg.radio_val].linear_gradient.end_color +
          infor.form_item_bg[infor.form_item_bg.radio_val].linear_gradient.end_pointer +
          '%)'
          : infor.form_item_bg[infor.form_item_bg.radio_val].color;
      return background;
    },
    se_formItemBg() {
      let infor = this.module.data.pc_widgets_infor;
      const background =
        infor.form_item_bg[infor.form_item_bg.radio_val].sePattern == 'linear_gradient'
          ? 'linear-gradient(' +
          infor.form_item_bg[infor.form_item_bg.radio_val].seLinear_gradient.deg +
          'deg,' +
          infor.form_item_bg[infor.form_item_bg.radio_val].seLinear_gradient.start_color +
          infor.form_item_bg[infor.form_item_bg.radio_val].seLinear_gradient.start_pointer +
          '%,' +
          infor.form_item_bg[infor.form_item_bg.radio_val].seLinear_gradient.end_color +
          infor.form_item_bg[infor.form_item_bg.radio_val].seLinear_gradient.end_pointer +
          '%)'
          : infor.form_item_bg[infor.form_item_bg.radio_val].seColor;
      return background;
    },
  },
  created() {
    //表单项内容 兼容处理
    this.templet.checkFormItemContentValue(this.pc_infor)
    // 表单项背景、边框兼容处理
    if (typeof this.pc_infor.form_item_bg == "undefined") {
      this.$set(this.pc_infor, "form_item_bg", basic_nleavemessage_new_style().form_item_bg);
      this.$set(this.pc_infor, "form_item_border", basic_nleavemessage_new_style().form_item_border);
    }
    if (typeof this.pc_infor.form_item_content.default.enterColor == "undefined") {
      this.$set(this.pc_infor.form_item_content.default, "enterColor", 'rgba(51,51,51,1)');
      this.$set(this.pc_infor.form_item_content.custom, "enterColor", 'rgba(51,51,51,1)');
    }
  },
  mounted() {
    let that = this;
    that.loading = true;
    setTimeout(() => {
      that.$nextTick(() => {
        that.$nextTick(() => {
          that.loading = false;
          that.list_sortable();
          this.my_resizable();
        });
      });
    }, 1000);
    that.$store.state.app.se_form_id[that.module.widgets_id] =
      that.module.data.listArr.id;
  }
};
</script>

<style lang="scss" scoped type="text/css">
input::-webkit-input-placeholder {
  font-style: var(--fsItalics);
  text-decoration: var(--fontUnderline);
  font-size: var(--fontSize);
  color: var(--fontColor);
  font-weight: var(--fsWeight);
  font-family: var(--fontFamily);
  text-align: var(--textAlign);
  background-image: var(--backgroundImage);
  -webkit-background-clip: text;
}

input:-moz-placeholder {
  font-style: var(--fsItalics);
  text-decoration: var(--fontUnderline);
  font-size: var(--fontSize);
  color: var(--fontColor);
  font-weight: var(--fsWeight);
  font-family: var(--fontFamily);
  text-align: var(--textAlign);
  background-image: var(--backgroundImage);
  -webkit-background-clip: text;
}

input::-moz-placeholder {
  font-style: var(--fsItalics);
  text-decoration: var(--fontUnderline);
  font-size: var(--fontSize);
  color: var(--fontColor);
  font-weight: var(--fsWeight);
  font-family: var(--fontFamily);
  text-align: var(--textAlign);
  background-image: var(--backgroundImage);
  -webkit-background-clip: text;
}

input:-ms-input-placeholder {
  font-style: var(--fsItalics);
  text-decoration: var(--fontUnderline);
  font-size: var(--fontSize);
  color: var(--fontColor);
  font-weight: var(--fsWeight);
  font-family: var(--fontFamily);
  text-align: var(--textAlign);
  background-image: var(--backgroundImage);
  -webkit-background-clip: text;
}

textarea::-webkit-input-placeholder {
  /* WebKit browsers */
  font-style: var(--fsItalics);
  text-decoration: var(--fontUnderline);
  font-size: var(--fontSize);
  color: var(--fontColor);
  font-weight: var(--fsWeight);
  font-family: var(--fontFamily);
  text-align: var(--textAlign);
  background-image: var(--backgroundImage);
  -webkit-background-clip: text;
}

textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-style: var(--fsItalics);
  text-decoration: var(--fontUnderline);
  font-size: var(--fontSize);
  color: var(--fontColor);
  font-weight: var(--fsWeight);
  font-family: var(--fontFamily);
  text-align: var(--textAlign);
  background-image: var(--backgroundImage);
  -webkit-background-clip: text;
}

textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-style: var(--fsItalics);
  text-decoration: var(--fontUnderline);
  font-size: var(--fontSize);
  color: var(--fontColor);
  font-weight: var(--fsWeight);
  font-family: var(--fontFamily);
  text-align: var(--textAlign);
  background-image: var(--backgroundImage);
  -webkit-background-clip: text;
}

textarea::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-style: var(--fsItalics);
  text-decoration: var(--fontUnderline);
  font-size: var(--fontSize);
  color: var(--fontColor);
  font-weight: var(--fsWeight);
  font-family: var(--fontFamily);
  text-align: var(--textAlign);
  background-image: var(--backgroundImage);
  -webkit-background-clip: text;
}

.module_content {
  overflow-x: hidden;
  .radio_item,.checkbox_item{
    color: var(--enterColor)
  }
}

.tips_size {
  display: none;
  padding: 2px 8px;
  border: 1px solid #f5e4b9;
  font-size: 13px;
  line-height: 21px;
  color: #333;
  background-color: #fffaee;
  border-radius: 2px;
  position: absolute;
  top: calc(100% + 5px);
  left: calc(100% + 5px);
  z-index: 9999999;

  .tips {
    word-break: normal;
    height: 20px;
    font-weight: normal;
    color: #333;
    font-size: 13px;
  }
}

.m_form .formitem_active_chosen .form_item {
  outline: 1px solid #5874d8 !important;
}

.mb_pattern .formitem_active_chosen .form_item {
  outline: 0 solid #5874d8 !important;
}

.m_form .form_title_text {
  word-break: normal;
}

.pc_pattern .formitem_active .form_item .resize_handler {
  display: block;
}

.pc_pattern .formitem_active .form_item {
  outline: 1px dashed #999 !important;
}

.pc_pattern .form_item_wrap .resize_handler {
  display: none;
}

.pc_pattern .form_item_wrap:hover .resize_handler {
  display: block;
}

.pc_pattern .form_item_wrap .resize_handler {
  z-index: 201;
  z-index: 201;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 9px;
  height: 9px;
  margin-bottom: 0px;
  margin-right: -5px;
  border: 1px dashed #999;
  border-radius: 50%;
  background: #fff;
  cursor: nw-resize;
  display: none;
}

.form_item_wrap .form_item {
  position: relative;
}

.form_item_wrap .form_item_select {
  outline-width: 1px !important;
}

.form_item_wrap {
  cursor: move;
  position: relative;
}

.jz_tooltip {
  position: relative;
  display: none;
}

.pc_pattern .form_item_wrap .form_item:hover {
  outline-width: 1px;

  .jz_tooltip {
    display: block;
  }
}

.pc_pattern .form_item_wrap .form_item {
  outline: 0 dashed #999;
}

.basic_nleavemessage_index {
  position: relative;
  box-sizing: border-box;
  min-height: 30px;
  min-width: 30px;
  height: 100%;

  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;
  }
}

.basic_nleavemessage {
  .textEdit {
    display: block;
    width: 100%;
    cursor: text;
    min-width: 10px;
    overflow: hidden;
    pointer-events: none;
  }
}

.s_0 {
  .input_style {
    background: rgba(204, 204, 204, 0.15);
  }
}

.s_1 {
  .input_style {
    border: 1px solid #e0e0e0;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    border-radius: 2px;
    background: #fff;
  }

  .textarea_style {
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    background: #fff;
  }
}

.s_2 {
  .input_style {
    border-bottom: 1px solid rgba(178, 178, 178, 0.25);
    background: #fff;
  }

  .textarea_style {
    border-bottom: 1px solid rgba(178, 178, 178, 0.25);
    background: #fff;
  }
}

.pc_pattern .form_item .input_style:hover, .form_item .textarea_style:hover {
  background: var(--sebackground) !important;
}

.pc_pattern .s_1 .input_style:hover,
.pc_pattern .s_1 .textarea_style:hover,
.pc_pattern .s_2 .input_style:hover,
.pc_pattern .s_2 .textarea_style:hover {
  border-top: var(--se_formItemBorderTop) !important;
  border-bottom: var(--se_formItemBorderBottom) !important;
  border-left: var(--se_formItemBorderLeft) !important;
  border-right: var(--se_formItemBorderRight) !important;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_nleavemessage/index.vue